import { ButtonGroup } from "../../../../../../utils/form";
import _ from "lodash";

const RecurringFrequency = props => {
  return (
    <ButtonGroup 
      form={props.form} 
      name="recurring.days"
      label="Se repite cada" 
      options={[{ label: "1 mes", value: 30 }, { label: "2 meses", value: 60 }, { label: "3 meses", value: 90 }]} 
      valueTextGetter={(item) => item.label}
      labelStyles={{
        direction: {
          xs: "column", sm: "row"
        },
        alignItems: {
          sm: "center"
        },
        spacing: { xs: 1, sm: 2 }
      }}
    />
  );
};

export default RecurringFrequency;